import { Container, Service, AppComponent, Browser, BrowserAdapter } from "@reporting/rp-app-host";
import { html, css } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { AnalyticsApplication } from "../..";
import { ContextHistoryBrowserAdapter } from "../../adapters/contextHistoryBrowserAdapter";
import rp from "@reporting/rp-app-host";

@customElement('rp-mf-history')
export class ContextHistoryList extends AppComponent<AnalyticsApplication> {

	static styles = css`
		* {
			box-sizing: border-box;
		}

		:host {
			display: block;
			width: 100%;
			height: 100%;
			position: relative;
			overflow: hidden;
		}

		rp-browser {
			height: 100%;
		}
	`;
	
	@query('rp-browser')
	browser: Browser;

	get app() { return rp.applications.get('analytics') as AnalyticsApplication }
	get service() { return rp.ms('analytics') }
	
	layout() {
		this.browser?.layout();
	}

	render = () => html`
		<rp-browser 
			.adapter="${new ContextHistoryBrowserAdapter(this.app.modules)}">
		</rp-browser>
	`;

}
